import React from "react";
import { IconButton, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {
    width: 30,
    height: 30,
  },
}));

/**
 * Expand/collapse toggle icon button used in MP/PI table rows.
 */
const ExpandCollapseButton = ({ expanded, onClick }) => {
  const classes = useStyles();

  return (
    <IconButton className={classes.root} disableRipple aria-label="expand" onClick={onClick}>
      <i className={expanded ? "far fa-angle-up" : "far fa-angle-down"} aria-hidden="true" />
    </IconButton>
  );
};

export default React.memo(ExpandCollapseButton);
